module.exports = __webpack_public_path__ + "static/media/response-simulator-screenshot.8222cecc.png";